import React, { useEffect, useState } from "react";
import style from "./Navbar.module.css";
import logo from "../images/480.png";
import NavButton from "./NavButton";

import { getData } from "../utils/dataLoader";

const Navbar = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    // Replace with your actual URL
    getData("/data/nav.json").then((data) => {
      if (data && data['nav-items']) {
        setItems(data['nav-items']);
      }
    });
  }, []);

  // Insert the logo at the desired index
  let image_index = 0; 
  const content = [...items.map((o) => (
    <NavButton key={o.name} name={o.name} link={o.link} />
  ))];

  content.splice(
    image_index,
    0,
    <div key="logo-div" className={style.logoDiv}>
      <div
        className={style.growOnHover}
      >
        <a href="/" target="_self">
          <img className={style.growOnHover} alt="The Logo" src={logo} />
        </a>
      </div>
    </div>
  );

  return (
    <ul className={style.nav}>
      {content}
    </ul>
  );
};

export default Navbar;
